import EmailLogSelectionBarContainer from './email-log-selection-bar.container';

export default EmailLogSelectionBarContainer;
